import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState, AppDispatch } from "../../../app/store";
import { logError } from "../../../utils/utils";
import { kenngroesse, messstelle } from "../../../utils/apiTypes";
import { anomalieGeneralObject, anomalieGeneralGrid } from "./anomalieTypes"
import { postJsonWithAuth } from "../../../utils/api";
import { errorHandler } from "../../../utils/errorHandling";


const initialState: anomalieGeneralGrid = {
    isLoadingGeneralGrid: false,
    kenngroesseHeaderListe: [],
    vertikalSumListe: [],
    horizentalSumListe: [],
    sumAll: 0,
    anomalieListe: [],
}

// Slice
const anomalieGeneralGridSlice = createSlice({
    name: "anomalieGeneralGrid",
    initialState,
    reducers: {
        setIsLoadingGeneralGrid: (state, action: PayloadAction<boolean>) => {
            state.isLoadingGeneralGrid = action.payload
        },

        setKenngroesseHeaderListe: (state, action: PayloadAction<Array<string>>) => {
            state.kenngroesseHeaderListe = action.payload
        },

        setVertikalSumListe: (state, action: PayloadAction<Array<number>>) => {
            state.vertikalSumListe = action.payload
        },

        setHorizentalSumListe: (state, action: PayloadAction<Array<number>>) => {
            state.horizentalSumListe = action.payload
        },

        setSumAll: (state, action: PayloadAction<number>) => {
            state.sumAll = action.payload
        },
        setAnomalieListe: (state, action: PayloadAction<Array<Array<anomalieGeneralObject>>>) => {
            state.anomalieListe = action.payload
        }
    }
})

// Selectors

//export const selectGeneralGrid = (state: RootState): Array<anomalieResultForGeneralGrid> => state.anomalieGeneralGrid.generalGrid;
export const selectIsLoadingGeneralGrid = (state: RootState): boolean => state.anomalieGeneralGrid.isLoadingGeneralGrid;
export const selectKenngroesseListe = (state: RootState): string[] => state.anomalieGeneralGrid.kenngroesseHeaderListe;
export const selectVertikalSumListe = (state: RootState): number[] => state.anomalieGeneralGrid.vertikalSumListe;
export const selectHorizentalSumListe = (state: RootState): number[] => state.anomalieGeneralGrid.horizentalSumListe;
export const selectSumAll = (state: RootState): number => state.anomalieGeneralGrid.sumAll;
export const selectAnomalieListe = (state: RootState): anomalieGeneralObject[][] => state.anomalieGeneralGrid.anomalieListe;

// Actions

export const {
    setIsLoadingGeneralGrid,
    setKenngroesseHeaderListe,
    setVertikalSumListe,
    setHorizentalSumListe,
    setSumAll,
    setAnomalieListe

} = anomalieGeneralGridSlice.actions;

//Getter
export const getAnomalienGeneral =
    (messstelleParam: Array<messstelle>, kenngroesseParam: Array<kenngroesse>, startParam: Date, endeParam: Date, anomalientypenParam: Array<string>, signifikanzParam: Array<string>,) => (
        dispatch: AppDispatch): void => {

        const body = {
            start: startParam,
            end: endeParam,
            kenngroessen: kenngroesseParam,
            messstellen: messstelleParam,
            anomalietypen: anomalientypenParam,
            signifikanz: signifikanzParam,
        }

        dispatch(setIsLoadingGeneralGrid(true))
        postJsonWithAuth("ANOMALIEGENERALTABLE", {}, body)
            .then((response: Array<Array<anomalieGeneralObject>>) => {

                dispatch(setAnomalieListe(response));

                const tempKenngroesseList: Array<string> = [];
                const tempSumHorizentalList: Array<number> = [];
                const tempSumVertikalList: Array<number> = [];
                let sumAll = 0;

                response.forEach(rows => {
                    let tempSumHorizental = 0;
                    rows.forEach(row => {
                        if (row.col != null) {
                            tempKenngroesseList.push(row.col)
                            tempSumHorizental += row.value; 
                            sumAll += row.value;
                        }
                    })
                    tempSumHorizentalList.push(tempSumHorizental) 
                });
                dispatch(setHorizentalSumListe(tempSumHorizentalList));

                tempKenngroesseList.sort((a, b) => a.localeCompare(b))
                const filteredKenngroesseList: Array<string> = tempKenngroesseList.filter(function (elem, pos) {
                    return tempKenngroesseList.indexOf(elem) == pos;
                })

                dispatch(setKenngroesseHeaderListe(filteredKenngroesseList));

                filteredKenngroesseList.forEach((elem) => {
                    let sumVertical = 0;
                    response.forEach((rows) => {
                        rows.forEach((row) => {
                            if (elem == row.col) {
                                sumVertical += row.value;
                                sumAll += row.value;
                            }
                        })
                    })
                    tempSumVertikalList.push(sumVertical);
                })
                dispatch(setVertikalSumListe(tempSumVertikalList));
                dispatch(setSumAll(sumAll));

            })
            .catch((error) => {
                logError(error);
                errorHandler(error, dispatch);
            }).finally(() => dispatch(setIsLoadingGeneralGrid(false)));
    };

export default anomalieGeneralGridSlice.reducer;
